import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {HttpService} from "../http.service";
import {ApiResponse} from "../../shared/model/response/ApiResponse";
import {ReportResponse} from "../../shared/model/response/report-response";
import {HttpUtils} from "../../shared/utils/http.utils";
import {ReportFilterModel} from "../../shared/model/request/report-filter.model";
import {DatePipe} from "@angular/common";


/**
 * The access service provides functions to handle user account access to the application
 * such as register, account activation.
 */
@Injectable({providedIn: "root"})
export class ReportService {

  private version = "/api/v1"
  private host = environment.host + this.version
  private baseUri = this.host + "/complaints"

  constructor(private genericHttp: HttpService, private datePipe: DatePipe) {
  }

  create(body: { eventId: number, message: string }): Observable<ApiResponse<any>> {
    return this.genericHttp.post(this.baseUri, body, {shouldShowLoading: true})
  }

  /**
   * retrives a page of complaints
   * @param page page
   * @param filters
   */
  page(page: number = 0, filters: ReportFilterModel): Observable<ApiResponse<ReportResponse[]>> {

    if (filters.reportDate) {
      filters.reportDate = this.datePipe.transform(filters.reportDate, 'yyyy-MM-dd');
    }

    let params = HttpUtils.convertObjectToParam(filters).append("page", page)

    return this.genericHttp.get(this.baseUri, {params, shouldShowLoading: true});
  }

  closeComplaint(complaintId: number): Observable<ApiResponse<any>> {
    const url = this.baseUri.concat("/", complaintId.toString(), "/status")
    return this.genericHttp.patch(url, null, {shouldShowLoading: true})
  }
}
